import { PERCENTAGE, PCT } from './constants';

// get percentage metric corresponding to input metric
// AI/EI percentage metric naming convention is different
const getPercentageMetric = (metric, allMetrics) => {
  if (metric === 'AdPlays') {
    return metric;
  }
  const metricName = [`${metric}${PERCENTAGE}`, `${metric}${PCT}`].find((m) => m in allMetrics);
  return metricName;
};

/*
  Function to add Percentage metrics to query metrics API
  Input: metrics array
  Output: Updated metrics array with percentage metrics
*/
export default (metrics, allMetrics) => {
  const metricPercentageList: any = [];
  metrics.forEach((metric) => {
    const percentageMetric = getPercentageMetric(metric, allMetrics);

    if (!allMetrics[metric].calcPercentage && percentageMetric) {
      metricPercentageList.push(percentageMetric);
    }
  });
  metrics.push(...metricPercentageList);
  return metrics;
};

export { getPercentageMetric };
